<template>
  <div class="page-annuaire-produit">
    <main class="main">
      <breadcrumbs></breadcrumbs>
      <div class="flex w-full justify-between">
        <div class="flex">
          
          <div class="flex flex-col mb-0">
            <div class="flex items-center">
              
              <div class="flex flex-col">
                <div class="flex">
                  <div>
                    <status-chip :status="product.status"></status-chip>
                  </div>
                  <h1 class="mb-0">
                    {{ product.name }}
                  </h1>
                </div>
              <div class="flex flex-wrap gap-2 mb-3">
                <div v-if="product.logo_biocontrole" class="has-tooltip">
                  <img
                    src="@/assets/images/logo-biocontrole.png"
                    alt="Logo Biocontrôle"
                  />
                  <span class="tooltip">PPP de biocontrôle (liste ministère)</span>
                </div>
                <div v-if="product.logo_ab_use" class="has-tooltip">
                  <img
                    src="@/assets/images/logo-ab-use.png"
                    alt="Logo Agriculture Biologique"
                  />
                  <span class="tooltip">Utilisable en agriculture biologique</span>
                </div>
                <div v-if="product.gamme_amateur" class="has-tooltip mt-1">
                  <img
                    width="30"
                    src="@/assets/images/brouette.jpg"
                    alt="Utilisable par les amateurs / EAJ"
                  />
                  <span class="tooltip">Utilisable par les amateurs / EAJ</span>
                </div>
                
              </div>
                </div>
              <div class="flex mb-1 ml-2"  v-if="product.firm_data.date_debut != null && product.firm_data.date_fin != null ? product.firm_data.display_logo : false" >
                  <a :href="product.firm_data.url" target="_blank">
                    <img
                    class="w-auto h-24 object-cover"
                    :src="`/media/${product.firm_data.logo}`"
                    :alt="product.firm_data.name"
                  />
                  </a>
              </div>
            </div>
            
          </div>
         
        </div>
     
   
      </div>

  

      <div class="main-content">
        <div class="onglets">
          <router-link
            class="onglet"
            v-for="route in routesLMR"
            :key="route.path"
            :to="{ name: route.name, query: route.meta.query }"
          >
            <button>{{ route.meta.label }}</button>
          </router-link>
          <div class="right-elem">
            <button
              v-if="favoriteProducts.includes(castedId)"
              @click="removeFavorite('products', castedId)"
              class="btn-fav btn-fav--faved"
            ></button>
            <button
              v-else
              @click="addFavorite('products', castedId)"
              class="btn-fav btn-fav"
            ></button>
          </div>
        </div>

        <router-view :product="product" :productId="id" />

        <div class="last-update">
          Données au :
          {{ product.last_phytcom_update }}
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Product from '@/api/products.js'
import FavoriteMixin from '@/mixins/FavoriteMixin.js'
import StatusChip from '@/components/StatusChip'
import Breadcrumbs from '@/components/Breadcrumbs'
import { findRouteChildren } from '@/utils/helpers'
import moment from "moment"

export default {
  name: 'Product',
  components: { Breadcrumbs, StatusChip },
  mixins: [FavoriteMixin],

  props: {
    id: String
  },

  data () {
    return {
      product: {},
      routes: []
    }
  },

  computed: {
    ...mapState('authent', {
      favoriteProducts: (state) => state.user?.favorite_products || []
    }),
    castedId () {
      return Number(this.id)
    },

    isProductBiocide () {
      return this.product.type === 'Biocide'
    },
    isProductMO () {
      return this.product.type === 'Macro-organisme'
    },
    routesLMR () {
      return this.routes.filter(route => this.isProductBiocide || this.isProductMO ? route.name != 'productLMR' : true)
    }

  },

  created () {
    this.getProduct()
    this.updateLastSeen('Product', this.castedId)

    const currentMatchedRoute = this.$route.matched.slice(-1)[0]
    const parentRoute = currentMatchedRoute.parent
    const productRouteChildren = findRouteChildren(
      parentRoute.name,
      this.$router.options.routes
    )

    this.routes = productRouteChildren.filter(
      (route) => route.meta && route.meta.label
    )
  },

  beforeRouteUpdate (to, from, next) {
    if (this.id !== to.params.id) {
      Promise.resolve(this.getProduct(to.params.id)).finally(() => next())
    } else {
      next()
    }
  },

  methods: {
    getProduct (id = this.id) {
      return Product.retrieve(id).then((response) => {
        this.product = response
      })
    },
    format_date(date) {
      moment().locale("fr");
      return moment(date).format("DD/MM/YYYY");
    },
  }
}
</script>
